module.exports = __webpack_public_path__ + "img/DSC_0282.NEF.e0f2b74d.jpg";